<template>
  <div class="select-product">
    <div class="select-product-title">
      <span class="title"
        ><em class="ico iconfont icon-meijin"></em
        >{{ selectProductTitle }}</span
      >
      <div
        v-if="isShowAboutPopup"
        class="tips j-about-tips"
        @click="showAboutPopup"
      >
        <span class="ico iconfont icon-wenhao"></span
        >{{ isJpPlatform ? '金銖について' : letter.voucherAbout }} >
      </div>
    </div>
    <div class="title-tips" v-if="gameId == '251'">
      <p>海神幣需要在登入遊戲後才能購買，請登入遊戲後再刷新當前頁面</p>
      <p>登錄有效時間：當日05:00-次日04:59</p>
    </div>
    <!-- 分类、排序、搜索 -->
    <div
      class="type-section"
      v-show="noSelectProduct && (productList.length || searchVal)"
      v-if="isPackageGame"
    >
      <!-- 商品分类 -->
      <div
        class="product-type-select-wrap"
        :class="{ expand: isExpandAllType }"
        v-show="productType && !!productType.length"
      >
        <div
          class="product-type-select"
          ref="productTypeWrap"
          id="productTypeWrap"
        >
          <div class="content" ref="productTypeContent">
            <div
              class="product-type-select-item j-select-product-type"
              :pointValue="item.value"
              pointClass="`j-select-product-type`"
              :class="{ active: curProductType == item.value }"
              :key="item.value"
              v-for="item in productType"
              @click="updateProductType(item.value)"
              :id="`j-product-type-${item.value}`"
            >
              <img
                :src="productTypeImg[item.value].img"
                class="type-img"
                alt=""
              />
              <p class="type-name">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div
          class="product-type-select-expand-switch"
          @click="closeAllType"
          v-if="isExpandAllType"
        >
          <span class="icon close"></span>
        </div>
        <div
          class="product-type-select-expand-switch"
          @click="expandAllType"
          v-else
        >
          <span class="icon"></span>
        </div>
      </div>
      <!-- 排序 + 搜索 -->
      <div class="sort-and-search">
        <div class="order-type-wrap" v-show="!isGoSearch || isLandscape">
          <button
            class="order-btn j-select-order"
            :class="{ active: curOrderType === 'normal' }"
            @click="updateOrderType('normal')"
          >
            {{ letter.hotSuggest }}
          </button>
          <span class="line">|</span>
          <button
            class="order-btn j-select-order"
            :class="{ active: curOrderType !== 'normal' }"
            @click="updateOrderType()"
          >
            {{
              curOrderType === 'priceDown'
                ? letter.storePriceDown
                : letter.storePriceUp
            }}
          </button>
        </div>
        <div class="search-content" v-show="isGoSearch || isLandscape">
          <div class="search-wrap">
            <span
              @click="visibleShowSearchTypeSelecter(true)"
              class="search-type-text"
              >{{ curSearchTypeText }}</span
            >
            <em
              class="search-type-switch-ico"
              @click="visibleShowSearchTypeSelecter(true)"
            ></em>
            <div class="search-input-wrap">
              <input
                :placeholder="searchPlaceholder[curSearchType]"
                class="search-input"
                v-model.trim="searchVal"
                type="search"
                ref="searchInput"
              />
              <em class="search-input-ico"></em>
            </div>
          </div>
          <div class="search-close" @click="clearSearch">
            <span class="search-close-icon"></span>
          </div>
        </div>
        <div
          class="search-wrap before"
          v-show="!isGoSearch && !isLandscape"
          @click="handleGoSeach"
        >
          <span>{{ letter.inputKeywordSearch }}</span>
          <em class="search-input-ico"></em>
        </div>
      </div>
      <p class="search-tips" v-if="!productList.length && searchVal">
        {{ letter.storeNoFindProduct }}
      </p>
    </div>
    <template v-if="(isPackageGame && noSelectProduct) || !isPackageGame">
      <div class="product-wrap" v-if="productList.length > 0">
        <product-item
          v-for="(item, index) in productList"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID + index"
          :item="item"
          @selectProduct="handleSelectProduct"
          :selectItem="selectItem"
          :isPreProduct="false"
        ></product-item>
      </div>
      <div class="product-wrap" v-else-if="!searchVal">
        <product-item
          v-for="(item, index) in preProductList"
          :key="item.PRODUCT_ID + index"
          :item="item"
          selectItem=""
          :isPreProduct="true"
          @selectProduct="handlerPopup"
        ></product-item>
      </div>
    </template>
    <div
      class="has-choose-product"
      v-if="isPackageGame && (hasSelectProduct || hasLoadPaytype)"
    >
      <product-item :item="selectItem" :selectItem="selectItem"></product-item>
      <div class="has-choose-product-btn">
        <button class="btn" @click="handleSelectProduct(selectItem, true)">
          {{ letter.lookProductContent }}
        </button>
        <button class="btn j-change-product" @click="handleReSelectProduct">
          {{ letter.productSwitch }}
        </button>
      </div>
    </div>
    <about-currency-popup
      v-bind:visible.sync="visibleCurrenyGuidePopup"
    ></about-currency-popup>
    <search-type-selecter
      v-if="showSearchTypeSelecter"
      @closeSelecter="showSearchTypeSelecter = false"
      :curType="curSearchType"
      :showChildSelector="showSearchTypeSelecter"
      :searchType="searchType"
      @selectType="selectType"
      style="z-index: 1002"
    ></search-type-selecter>
    <product-detail-popup
      v-bind:visible.sync="productDetailPopup.visible"
      :product="productDetailPopup.product"
      :onlyDetail="productDetailPopup.onlyDetail"
      @selectProduct="selectProduct"
    ></product-detail-popup>
  </div>
</template>

<script type="text/javascript">
import { getProductDefaultImg } from '@utiles/officialStore/productImg';
import globalConfig from '@utiles/officialStore/globalConfig';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import {
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_LOADING,
  LOAD_PAYTYPE_LIST_DATA,
  UPDATE_HAS_SELECT_PRODUCT,
  GET_PRE_PRODUCT_LIST,
  UPDATE_IS_AUTO_MATCH_PRODUCT
} from '@store/officialWebStore';
import {
  storeProductParam,
  storeCpProductId,
  getCurLocation,
  setDefaultPrice
} from '@store/officialWebStore/storager';
import ProductItem from '@components/officialWebStore/product/ProductItem.vue';
import SearchTypeSelecter from '@components/officialWebStore/product/SearchTypeSelecter';
import ProductDetailPopup from '@components/officialWebStore/product/ProductDetailPopup.vue';
import AboutCurrencyPopup from '@components/officialWebStore/AboutCurrencyPopup.vue';
import coupon from '@mixins/officialWebStore/coupon';
import login from '@mixins/officialWebStore/login';
import pay from '@mixins/officialWebStore/pay';
import { mapState, mapGetters } from 'vuex';
import { getGameLanguage } from '@store/officialWebStore/gameConf';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import {
  popupType,
  showPopup,
  clickButton,
  locationType
} from '@plugins/biPoint/_configWebstoreV2';
import BScroll from 'better-scroll';

const isFromIframe = globalConfig.getHrefParam('fromIframe') || '';
const PRODUCT_OFF_POPUP_HIDE = 'PRODUCT_OFF_POPUP_HIDE';
const PACKAGE_TAG_LIST = [
  'hot',
  'discount',
  'double',
  'treble',
  'sale',
  'top_seller',
  'off_10',
  'off_20',
  'off_30',
  'off_40',
  'off_50',
  'off_60',
  'off_70',
  'off_80',
  'off_90',
  'event',
  'daily',
  'weekly',
  'monthly'
];
export default {
  name: 'webSelectProduct',
  mixins: [coupon, login, pay],
  data() {
    return {
      uidGame: globalConfig.isUidGame(),
      mainHost: globalConfig.getMainHost(),
      curOrderType: 'normal',
      curProductType: '',
      searchVal: '',
      scroll: null,
      selectItem: {},
      hasAutoSelect: false,
      curSearchType: 'name',
      PRODUCT_OFF_POPUP_HIDE,
      preProductList: [],
      visibleCurrenyGuidePopup: false,
      isExpandAllType: false,
      showSearchTypeSelecter: false,
      isGoSearch: false,
      productDetailPopup: {
        visible: false,
        product: {},
        onlyDetail: false
      },
      isLandscape: window.innerWidth > window.innerHeight
    };
  },
  created() {
    this.$store.dispatch(GET_PRE_PRODUCT_LIST).then(data => {
      this.preProductList = data;
      // 需求方：区天衡 - 斗罗3D台港澳只显示PRODUCT_ID为showProductIdArr中的代币商品项
      if (+this.$store.state.gameId === 251) {
        let productList = [];
        for (let item of data) {
          let showProductIdArr = [
            'dlssr.app.hsbtw_33',
            'dlssr.app.hsbtw_170',
            'dlssr.app.hsbtw_330',
            'dlssr.app.hsbtw_670',
            'dlssr.app.hsbtw_1690',
            'dlssr.app.hsbtw_3290',
            'dlssr.app.hsbtw_4990'
          ];
          if (
            item.PRODUCT_ID &&
            showProductIdArr.includes(String(item.PRODUCT_ID))
          ) {
            productList.push(item);
          }
        }
        this.preProductList = productList;
      }
      // 需求方：庄恺杰 - ROV隐藏PRODUCT_ID为hideProductIdArr中的代币商品项
      if (+this.$store.state.gameId === 371) {
        let productList = [];
        for (let item of data) {
          let hideProductIdArr = [
            'com.gravitygamehub.ragnarokvertical.aos.dm1_1',
            'com.gravitygamehub.ragnarokvertical.aos.dm2_1',
            'com.gravitygamehub.ragnarokvertical.aos.dm3_1',
            'com.gravitygamehub.ragnarokvertical.aos.dm4_1',
            'com.gravitygamehub.ragnarokvertical.aos.dm5_1',
            'com.gravitygamehub.ragnarokvertical.aos.dm6_1'
          ];
          if (
            item.PRODUCT_ID &&
            !hideProductIdArr.includes(String(item.PRODUCT_ID))
          ) {
            productList.push(item);
          }
        }
        this.preProductList = productList;
      }
    });
  },
  watch: {
    allProductList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        let productId = globalConfig.getHrefParam('productId') || '';
        let cpProductId = globalConfig.getHrefParam('cpProductId') || '';
        let productList = newVal;
        if (!this.hasAutoSelect && productList?.length > 0) {
          // 自动选中链接带的商品只匹配product_id
          if (
            [
              335, 274, 340, 337, 310, 339, 349, 303, 301, 285, 295, 379, 371,
              389, 356, 390, 381, 382, 251, 401
            ].includes(+this.gameId) &&
            productId
          ) {
            const productItem = productList.find(
              item => item.PRODUCT_ID == productId
            );
            if (productItem) {
              this.autoSelectProduct(productItem);
              return;
            } else {
              this.$store.commit(UPDATE_IS_AUTO_MATCH_PRODUCT, false);
              errorReport(ERROR_TYPE.AUTO_MATCH_PRODUCT_FAIL, {
                productId,
                cpProductId
              });
            }
          }
          // 自动选中链接带的商品匹配product_id和cp_product_id
          if (productId && cpProductId) {
            const productItem = productList.find(
              item =>
                item.CP_PRODUCT_ID == cpProductId &&
                item.PRODUCT_ID == productId
            );
            if (productItem) {
              this.autoSelectProduct(productItem);
              return;
            } else {
              this.$store.commit(UPDATE_IS_AUTO_MATCH_PRODUCT, false);
              errorReport(ERROR_TYPE.AUTO_MATCH_PRODUCT_FAIL, {
                productId,
                cpProductId
              });
            }
          }
        }
        // 自动选中第一个商品
        if (productList?.length > 0 && !this.isPackageGame) {
          this.autoSelectProduct(productList[0]);
        }
      }
    },
    lang(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      }
    },
    gameActiveCouponId() {
      this.curProductType = 'typeall';
    },
    productType: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.isCustomProductType) {
          return;
        }
        this.$nextTick(() => {
          this.initProductTypeExpand();
        });
      }
    },
    searchVal(newVal) {
      window.webstorev2DataLayer.push({
        eventName: 'search_product',
        eventType: this.curSearchType,
        eventReason: newVal
      });
    }
  },
  computed: {
    ...mapState({
      hasSelectProduct: state => state.hasSelectProduct,
      lang: state => state.lang,
      allProductList: state => state.productList,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isLogin: state => state.login.isLogin,
      uid: state => state.login.uid,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig', 'isPackageGame', 'isJpPlatform']),
    noSelectProduct() {
      return !this.hasSelectProduct;
    },
    productList() {
      let realProductList = [].concat(
        this.searchVal.length
          ? this.searchProductList
          : this.$store.state.productList
      );
      let _productList = this.filterHideProduct(realProductList);
      _productList = this.filterUseGameCoupon(_productList);
      return this.filterOrder(_productList);
    },
    searchProductList() {
      return this.curSearchType === 'name'
        ? this.$store.getters.getProductListByName(this.searchVal)
        : this.$store.getters.getProductListByPrice(this.searchVal);
    },
    currencyTips() {
      return getGameLanguage(
        this.$store.state.lang,
        'currencyTips',
        this.gameId
      );
    },
    // 韩国大千
    isXddqkr() {
      return +this.gameId === 340;
    },
    // 欧美小鸡出击
    isBawk() {
      return +this.gameId === 365;
    },
    // ROV东南亚版
    isRov() {
      return +this.gameId === 371;
    },
    // 休闲三消全球版
    isCodemr() {
      return +this.gameId === 286;
    },
    selectProductTitle() {
      if (this.isXddqkr && this.$store.state.lang === 'ko-KR') {
        return '천지기연 구매';
      }
      if (this.isBawk) {
        return 'In-game Currency';
      }
      if (this.isRov) {
        return this.letter.pay;
      }
      return this.letter.selectProductTitle;
    },
    isShowAboutPopup() {
      if (this.isXddqkr || this.isBawk || this.isRov || this.isCodemr) {
        return false;
      }
      return true;
    },
    productTypeImg() {
      return this.gameInfoConfig.productType;
    },
    isCustomProductType() {
      return this.gameInfoConfig.isCustomProductType;
    },
    productTypeLang() {
      return this.gameInfoConfig.productTypeLang[this.lang];
    },
    productType() {
      const TYPES_NAME = {
        coin: this.letter.coinTypeName,
        package: this.letter.packageTypeName,
        subscription: this.letter.subscriptionTypeName,
        currency: this.letter.currencyTypeName,
        typeall: this.letter.typeall
      };
      let res = [];
      if (this.$store.state.productTypes.length < 1) {
        this.curProductType = '';
        return res;
      }
      this.$store.state.productTypes.map(item => {
        if (item) {
          res.push({
            name: this.isCustomProductType
              ? this.productTypeLang[item] || this.letter[item] || ''
              : TYPES_NAME[item],
            value: item
          });
        }
      });
      this.curProductType = res[0].value;
      return res;
    },
    searchType() {
      return [
        { name: this.letter.product, value: 'name' },
        { name: this.letter.price, value: 'price' }
      ];
    },
    searchPlaceholder() {
      return {
        name: this.letter.storeInputNameSearch,
        price: this.letter.storeInputPriceSearch
      };
    },
    curSearchTypeText() {
      return this.searchType.find(item => item.value === this.curSearchType)
        ?.name;
    }
  },
  methods: {
    handlerPopup() {
      clickButton({
        btnName: 'pre_product_click',
        locationKey: locationType.homePage
      });
      if (!this.isLogin) {
        this.showLoginPopup();
        return;
      }
      this.showSelectRolePopup();
    },
    showAboutPopup() {
      this.visibleCurrenyGuidePopup = true;
      clickButton({
        btnName: 'about_currency_click',
        locationKey: locationType.homePage
      });
      showPopup(popupType.aboutCurrencyPopup);
    },
    autoSelectProduct(item) {
      this.$store.commit(UPDATE_IS_AUTO_MATCH_PRODUCT, true);
      this.hasAutoSelect = true;
      this.selectProduct(item, true);
    },
    selectProduct(item, isAutoSelect = false) {
      if (this.hasLoadPaytype) {
        this.changeProduct();
      }
      let productId = item.PRODUCT_ID,
        cpProductId = item.CP_PRODUCT_ID,
        remark = item.REMARK;

      this.updateSelectProduct(item);
      const serverId = this.$store.state.serverId;
      const roleId = this.$store.state.roleId;
      if (!serverId || !roleId) {
        alert(this.letter.seletGameInfoFirst);
        return;
      }
      // 搜索打点
      if (this.searchVal.length) {
        commonEmitUpload(
          `search-product-by-${this.curSearchType}`,
          {
            event: `search-product-by-${this.curSearchType}`,
            newPage: true,
            pageName: 'select-product-page',
            type: 'click'
          },
          this.searchVal
        );
      }
      commonEmitUpload(
        `j-select-product`,
        {
          event: `click-update-product`,
          pageName: 'select-product-page',
          type: 'click'
        },
        productId + ';' + cpProductId || ''
      );
      window.webstorev2DataLayer.push({
        eventName: 'select_product',
        eventReason: isAutoSelect ? 'auto_select' : 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: cpProductId,
          product_id: productId,
          product_num: 1,
          product_currency: this.currency,
          product_money: item.GAME_AMOUNT || ''
        }
      });
      // 保存跳到储值页前的链接，为了返回时能获取跳过去前的信息
      const saveLinks =
        '?gameId=' +
        this.$store.state.gameId +
        '&serverId=' +
        serverId +
        '&roleId=' +
        roleId +
        '&roleName=' +
        encodeURIComponent(this.$store.state.roleName) +
        '&productId=' +
        productId +
        '&cpProductId=' +
        cpProductId +
        '&remark=' +
        remark +
        '&loginAccount=' +
        this.$store.state.login.loginAccount +
        '&userId=' +
        this.$store.state.login.uid +
        '&web=1' +
        '&language=' +
        this.$store.state.lang +
        '&appLanguage=' +
        this.$store.state.lang +
        '&fromIframe=' +
        isFromIframe +
        '&cid=' +
        globalConfig.getHrefParam('cid') +
        '&scid=' +
        globalConfig.getHrefParam('scid') +
        '&packageName=' +
        globalConfig.getHrefParam('packageName') +
        '&hideService=' +
        globalConfig.getHrefParam('hideService') +
        '&productType=' +
        item.PRODUCT_TYPE +
        '#/web';
      sessionStorage.setItem('forwardLinksParam', saveLinks);
      storeProductParam({
        gameId: this.$store.state.gameId,
        serverId: this.$store.state.pcServerId,
        roleId: roleId,
        roleName: this.$store.state.roleName,
        packageName: globalConfig.getHrefParam('packageName'),
        userId: this.uid,
        productId: productId,
        cpProductId: cpProductId,
        devicePlate: globalConfig.getHrefParam('devicePlate'),
        remark: remark,
        location: getCurLocation() || '',
        appLanguage: this.$store.state.lang,
        language: this.$store.state.lang,
        productType: item.PRODUCT_TYPE
      });
      storeCpProductId(cpProductId);
      globalConfig.storeEntryParams();
      setDefaultPrice('');
      this.$store.commit(UPDATE_LOADING, true);
      this.$store.dispatch(LOAD_PAYTYPE_LIST_DATA);
    },
    updateOrderType(value) {
      if (value === 'normal') {
        this.curOrderType = value;
        clickButton({
          btnName: 'switch_sorting',
          locationKey: 'auto'
        });
        return;
      }
      if (this.curOrderType === 'priceUp') {
        this.curOrderType = 'priceDown';
        clickButton({
          btnName: 'switch_sorting',
          locationKey: 'price_down'
        });
      } else {
        this.curOrderType = 'priceUp';
        clickButton({
          btnName: 'switch_sorting',
          locationKey: 'price_up'
        });
      }
    },
    getProductDefaultIcon(type) {
      return getProductDefaultImg(type);
    },
    updateSelectProduct(item) {
      this.selectItem = item;
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, true);
    },
    changeProduct() {
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
    },
    filterHideProduct(realProductList) {
      let productList = [];
      for (let key in realProductList) {
        //需求方：区天衡 -  如果CP_PRODUCT_ID为10_1_-1 11_1_-1 12_1_-1 13_1_-1 426005_1_-1，则不显示
        let hideProductArr = [
          '10_1_-1',
          '11_1_-1',
          '12_1_-1',
          '13_1_-1',
          '426005_1_-1'
        ];
        if (
          realProductList[key].CP_PRODUCT_ID &&
          hideProductArr.includes(String(realProductList[key].CP_PRODUCT_ID))
        ) {
          continue;
        }

        if (
          this.curProductType &&
          this.curProductType !== 'typeall' &&
          this.curProductType != realProductList[key].itemType
        ) {
          continue;
        }

        productList.push(realProductList[key]);
      }

      return productList;
    },
    filterUseGameCoupon(productList) {
      if (
        this.gameActiveCouponId &&
        this.activeGameCouponProductList.length > 0
      ) {
        return productList.filter(item => {
          return this.checkInGameActiveCoupon(
            item.PRODUCT_ID,
            item.CP_PRODUCT_ID
          );
        });
      }
      return productList;
    },
    updateProductType(value) {
      clickButton({
        btnName: 'switch_producttype',
        locationKey: value
      });
      this.curProductType = value;
      this.scrollToType();
    },
    initProductTypeExpand() {
      if (this.isExpandAllType) {
        this.expandAllType();
      } else {
        this.closeAllType();
      }
    },
    expandAllType() {
      this.isExpandAllType = true;
      this.scroll?.destroy();
      this.scroll = null;
      [
        'width',
        'transform',
        'transitionTimingFunction',
        'transitionProperty',
        'transitionDuration'
      ].forEach(key => {
        this.$refs.productTypeContent.style[key] = 'unset';
      });
    },
    closeAllType() {
      this.isExpandAllType = false;
      this.initTypeScroll();
    },
    initTypeScroll() {
      if (!this.productType.length) {
        return;
      }
      // 动态计算每个item的宽度，然后累加
      let width = 0;
      this.productType.forEach(item => {
        const ele = document.getElementById(`j-product-type-${item.value}`);
        if (ele) {
          width += ele.offsetWidth + 20;
        }
      });
      this.$refs.productTypeContent.style.width = width + 'px';
      if (this.scroll) {
        this.scroll.refresh();
      } else {
        // productTypeWrap被绑定的这个元素要使用v-show，v-if会在其它操作触发后重新加载，导致该元素被销毁重建，ref绑定的是已经销毁的元素
        this.scroll = new BScroll(this.$refs.productTypeWrap, {
          mouseWheel: true,
          scrollX: true,
          click: true
        });
      }
      this.scrollToType();
    },
    scrollToType() {
      this.$nextTick(() => {
        if (this.curProductType && this.scroll) {
          const ele = document.getElementById(
            `j-product-type-${this.curProductType}`
          );
          if (ele) {
            this.scroll?.scrollToElement(ele, 300, true, true);
          }
        }
      });
    },
    selectType(type) {
      this.curSearchType = type;
      this.showSearchTypeSelecter = false;
    },
    filterOrder(productList) {
      let res = [];
      let isPackage = this.curProductType == 'package';

      switch (this.curOrderType) {
        // 默认排序
        case 'normal': {
          let tagArr = [];
          let notagArr = [];
          // 先区分是否有tag
          productList.forEach(item => {
            // 只处理礼包的tag，非礼包的不处理
            if (isPackage) {
              if (item.PRODUCT_TAG) {
                // 插入的时候排一下序（tag权重）
                let orderIndex = tagArr.length - 1;
                let isAdd = false;
                while (~orderIndex) {
                  const preTagOrder = PACKAGE_TAG_LIST.indexOf(
                    tagArr[orderIndex].PRODUCT_TAG
                  );
                  const curTagOrder = PACKAGE_TAG_LIST.indexOf(
                    item.PRODUCT_TAG
                  );
                  if (preTagOrder >= curTagOrder) {
                    tagArr.splice(+orderIndex + 1, 0, item);
                    isAdd = true;
                    break;
                  } else {
                    orderIndex--;
                  }
                }
                if (!isAdd) {
                  tagArr.unshift(item);
                }
              } else {
                notagArr.push(item);
              }
            } else {
              notagArr.push(item);
            }
          });
          // 如果都没有tag，就可以结束了
          if (!tagArr.length) {
            res = notagArr;
            break;
          }
          res = tagArr.concat(notagArr);
          break;
        }
        // 价格升序
        case 'priceUp': {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT > +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        // 价格降序
        case 'priceDown': {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT < +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        default:
          break;
      }
      return res;
    },
    visibleShowSearchTypeSelecter(isShow) {
      this.showSearchTypeSelecter = isShow;
    },
    handleSelectProduct(item, onlyDetail = false) {
      if (this.isPackageGame) {
        this.productDetailPopup.product = item;
        this.productDetailPopup.visible = true;
        this.productDetailPopup.onlyDetail = onlyDetail;
        if (onlyDetail) {
          clickButton({
            btnName: 'show_product_detail',
            locationKey: locationType.selectProduct
          });
          showPopup(popupType.showProductDetailPopup);
        } else {
          clickButton({
            btnName: 'confirm_product',
            locationKey: locationType.selectProduct
          });
          showPopup(popupType.confirmProductPopup);
        }
        return;
      }
      this.selectProduct(item);
    },
    clearSearch() {
      this.searchVal = '';
      this.isGoSearch = false;
    },
    handleGoSeach() {
      this.isGoSearch = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    }
  },
  components: {
    ProductItem,
    AboutCurrencyPopup,
    SearchTypeSelecter,
    ProductDetailPopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
@import '@assets/scss/officialWebStore/_dimen.scss';
.select-product {
  padding: 0 20px;
  width: 710px;
  margin: 0 auto;
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px auto;
    .title {
      color: #333;
      font-size: 26px;
      font-weight: bold;
      margin: 0;
    }
    .tips {
      display: flex;
      align-items: center;
      font-size: 22px;
      color: $btnBg;
      cursor: pointer;
      .ico {
        display: inline-block;
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .title-tips {
    font-size: 18px;
    line-height: 22px;
    color: #333;
    margin: -20px 0 30px;
  }
  .product-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
    .tip {
      width: 100%;
      text-align: center;
      font-size: 24px;
      color: $btnBg;
    }
  }
  .icon-meijin {
    font-size: 33px;
    margin-right: 9px;
  }
}
.unlogin-tip {
  text-align: center;
  font-size: 24px;
  color: #c1a15e;
}

.type-section {
  .product-type-select-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    &.expand {
      align-items: flex-start;
      .product-type-select {
        height: auto;
        .content {
          flex-wrap: wrap;
        }
        &-item {
          margin-bottom: 20px;
          margin-left: 0;
          margin-right: 20px;
        }
      }
    }
  }
  .product-type-select {
    overflow: -moz-scrollbars-none;
    overflow-x: hidden;
    overflow-y: auto;
    width: 616px;
    height: 50px;
    white-space: nowrap;
    touch-action: none;
    touch-action: pan-y;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .content {
      display: flex;
      justify-content: flex-start;
    }
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 0 20px;
      height: 50px;
      flex-shrink: 0;
      margin-left: 20px;
      cursor: auto;
      text-align: center;
      font-size: 22px;
      color: #333333;
      touch-action: none;
      touch-action: pan-y;
      background: #fff;
      border-radius: 30px;
      @include g-border(2px);
      box-sizing: border-box;
      &.active {
        touch-action: none;
        color: $btnBg;
        box-shadow: unset;
      }
      &:hover {
        cursor: pointer;
        box-shadow: unset;
      }
      &:last-child {
        margin-right: 0;
      }
      &:first-child {
        margin-left: 0;
      }
      .type-img {
        width: 32px;
        height: auto;
        margin-right: 14px;
      }
    }
    &-expand-switch {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      padding: 0 20px;
      border-radius: 30px;
      border: 2px solid $border;
      box-sizing: border-box;
      height: 50px;
      cursor: pointer;
      .icon {
        display: inline-block;
        background: url($tmslgImg + 'channel-more.png') no-repeat;
        width: 20px;
        height: 19px;
        &.close {
          transform: rotate(180deg);
        }
      }
    }
  }

  .search-tips {
    font-size: 22px;
    color: $btnBg;
    margin: 20px 0;
    text-align: center;
  }
}

.sort-and-search {
  display: flex;
  justify-content: space-between;
  // background-image: linear-gradient(to bottom, $lightBg, #fff);

  .order-type-wrap {
    display: flex;
    align-items: center;
    font-size: 22px;
    color: #333;
    margin-bottom: 40px;
    .order-btn {
      cursor: pointer;
      font-size: 22px;
      &:hover {
        font-weight: bold;
      }
      &.active {
        font-weight: bold;
      }
    }
    .line {
      margin: 0 10px;
    }
  }
  .search-content {
    width: 100%;
    display: flex;
    align-items: start;
    justify-content: space-between;
  }

  .search-wrap {
    flex-grow: 1;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 30px;
    padding: 0 20px;
    color: #333333;
    height: 45px;
    box-sizing: border-box;
    border: 2px solid $border;
    font-size: 22px;
    margin-bottom: 40px;
    &.before {
      position: relative;
      width: 292px;
      justify-content: space-between;
      color: #999999;
      flex-grow: unset;
      cursor: pointer;
      .search-input-ico {
        position: relative;
        right: unset;
        top: unset;
        transform: unset;
      }
    }
    .search-type-text {
      cursor: pointer;
    }
    .search-type-switch-ico {
      display: inline-block;
      width: 16px;
      height: 9px;
      background: url($tmslgImg + 'lang-sanjiao.png') no-repeat;
      margin-left: 10px;
      cursor: pointer;
    }
    .search-input-wrap {
      position: relative;
      margin-left: 20px;
      flex-grow: 1;
      height: 45px;
    }
    .search-input {
      display: inline-block;
      box-sizing: border-box;
      width: 100%;
      padding: 0 50px 0 0;
      outline: none;
      background-color: transparent;
      background-size: cover;
      line-height: 45px;
      font-size: 22px;
      color: #333333;
      &::-webkit-search-cancel-button {
        display: none;
      }
    }
    .search-input-ico {
      display: inline-block;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 25px;
      height: 25px;
      background: url($tmslgImg + 'search-ico.png') no-repeat;
      background-size: cover;
    }
  }
  .search-close {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    border: 2px solid $border;
    padding: 0 20px;
    margin-left: 12px;
    height: 45px;
    background: #fff;
    width: 64px;
    box-sizing: border-box;
    cursor: pointer;
    &-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url($tmslgImg + 'search-close.png') no-repeat;
      background-size: cover;
    }
  }
}

.has-choose-product {
  display: flex;
  justify-content: space-between;
  &-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 143px;
    flex-grow: 1;
    margin-left: 16px;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      border-radius: 10px;
      font-size: 24px;
      color: #333;
      background: #fff;
      border: 2px solid $border;
    }
  }
}

@media screen and (orientation: landscape) {
  .select-product {
    width: 100%;
    padding: 0;
    .icon-meijin {
      font-size: 30px;
    }
    &-title {
      margin: 0 auto 30px;
      .title {
        color: #333;
        font-size: 22px;
        display: flex;
        align-items: center;
      }
      .tips {
        font-size: 16px;
      }
    }
    .product-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .tip {
        font-size: 18px;
      }
    }
  }
  .type-section {
    .product-type-select {
      width: 770px;
      &-item {
        font-size: 18px;
      }
    }
  }
  .sort-and-search {
    .order-type-wrap {
      .order-btn {
        font-size: 18px;
      }
    }
    .search-content {
      width: 500px;
    }
    .search-wrap {
      font-size: 16px;
      .search-input {
        font-size: 16px;
      }
    }
  }
  .has-choose-product {
    flex-direction: column;
    &-btn {
      height: 116px;
      margin-left: 0;
      justify-content: start;
      .btn {
        font-size: 18px;
        height: 39px;
        border-radius: 30px;
        width: 279px;
        flex-grow: unset;
        margin-bottom: 10px;
        &:hover {
          border: 2px solid $borderActive;
        }
      }
    }
  }
}
</style>
